import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PhoneState {
  countryCode: string;
  msisdn: string;
}

const initialState: PhoneState = {
  countryCode: localStorage.getItem("countryCode") ?? "",
  msisdn: localStorage.getItem("msisdn") ?? "",
};

const phoneSlice = createSlice({
  name: "phone",
  initialState,
  reducers: {
    setPhoneData: (
      state,
      action: PayloadAction<{ countryCode: string; msisdn: string }>
    ) => {
      state.countryCode = action.payload.countryCode;
      state.msisdn = action.payload.msisdn;

      // Save to localStorage
      localStorage.setItem("countryCode", state.countryCode);
      localStorage.setItem("msisdn", state.msisdn);
    },

    clearPhoneData: (state) => {
      state.countryCode = "";
      state.msisdn = "";
      localStorage.removeItem("countryCode");
      localStorage.removeItem("msisdn");
    },
  },
});

export const { setPhoneData, clearPhoneData } = phoneSlice.actions;
export default phoneSlice.reducer;
